import type { FunctionComponent } from 'react';
import React from 'react';
import { forTemplate } from '@trello/i18n';
import { CalendarIcon } from '@trello/nachos/icons/calendar';
import { DynamicButton } from '@trello/dynamic-tokens';

const format = forTemplate('board_header');

interface CalendarBoardButtonProps {
  onClick: () => void;
}

export const CalendarBoardButton: FunctionComponent<CalendarBoardButtonProps> = ({
  onClick,
}) => {
  return (
    <div>
      <DynamicButton
        style={{ margin: '0 4px 0 0' }}
        iconBefore={<CalendarIcon />}
        onClick={onClick}
      >
        {format('calendar')}
      </DynamicButton>
    </div>
  );
};
